import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { ActionRow } from "Components/Shared/ActionRow";
import { useAccountDeleteDialog } from "Hooks/useAccountDeleteDialog";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  account: BankAccountListItem;
};

export const BankAccountDisconnect = ({ account }: Props) => {
  const { t } = useResource();
  const {
    open: openDeleteConfirmationDialog,
    isPending: isDeletePending,
    deleteConfirmDialog,
  } = useAccountDeleteDialog({ account });

  return (
    <>
      <ActionRow
        variant="destructive"
        icon={<LogoutOutlinedIcon />}
        title={t(Resources.Pages.Content.BankAccounts.AccountMenu.Remove)}
        onClick={openDeleteConfirmationDialog}
        isDisabled={isDeletePending}
      />
      {deleteConfirmDialog}
    </>
  );
};
